import { Injectable } from '@angular/core';
import { Actions } from '@ngrx/effects';
import { Action } from '@ngrx/store';
import { EntityDataServiceAccessorService } from '@pit/core-data';
import { EntityStoreEffects } from '@pit/core-store';
import { IDtoShipmentProcess } from '@pit/frontend-model';
import { Observable } from 'rxjs';
import { DtoShipmentProcessStoreFactory } from './dto.shipment.process.store.factory';

@Injectable()
export class DtoShipmentProcessEffects extends EntityStoreEffects<IDtoShipmentProcess> {

    constructor(actions$: Actions, dataServiceAccessor: EntityDataServiceAccessorService) {
        super('dto.shipment.process', actions$, DtoShipmentProcessStoreFactory.instance, dataServiceAccessor);
    }

    loadShipmentProcessesActiveForDepot$: Observable<Action> = DtoShipmentProcessStoreFactory.instance.getEffect('get.active.by.depot')(this.actions$, this.dataServiceAccessor);

    loadShipmentProcessesToReturnForDepot$: Observable<Action> = DtoShipmentProcessStoreFactory.instance.getEffect('get.returns.by.depot')(this.actions$, this.dataServiceAccessor);

}
